// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container_19h3g","footer":"NotFound_footer_3AowN"};